import React, { useEffect, useState } from "react";
import "./BlockKeywordScreen.css";
import { deleteBlockKeyword, getBlockKeyword } from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import AddNewKeyword from "../block-keyword/AddNewKeyword";
import { MdDelete } from "react-icons/md";
import ConfirmationModal from "../../../components/common/ConfirmModal";

const BlockKeywordPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [keywordToDelete, setKeywordToDelete] = useState(null);

  const fetchBlockKeywordData = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getBlockKeyword(currentPage, searchTerm);
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };

  const confirmDelete = (id) => {
    setKeywordToDelete(id);
    setShowConfirmModal(true);
  };

  const handleModalResolve = async (confirmed) => {
    setShowConfirmModal(false);
    if (confirmed && keywordToDelete) {
      try {
        await deleteBlockKeyword(keywordToDelete);
        toast.success("Keyword deleted successfully");
        fetchBlockKeywordData(currentPage, searchTerm);
      } catch (err) {
        toast.error("Failed to delete keyword");
      }
    }
    setKeywordToDelete(null);
  };

  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchBlockKeywordData(1, searchTerm);
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchBlockKeywordData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  return (
    <div className="block-key-table-container">
      <div className="block-key-add">
        <div className="block-key-heading">
          <h2 className="block-key-table-title">Block Keyword</h2>
          <input
            className="block-key-input-field-container"
            type="text"
            placeholder="enter keyword"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div>
          <button className="keyword-add-button" onClick={() => setIsAddModalOpen(true)}>
            Add +
          </button>
        </div>
      </div>

      <table className="block-key-table">
        <thead>
          <tr>
            <th>Keyword</th>
            <th>Created at</th>
            <th>Updated at</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : statusData?.length > 0 ? (
            statusData.map((item, index) => (
              <tr key={index}>
                <td>{item?.keyword || "-"}</td>
                <td>
                  {new Date(item?.createdAt).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })}
                </td>
                <td>
                  {new Date(item?.updatedAt).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })}
                </td>
                <td>
                  <MdDelete size={22} onClick={() => confirmDelete(item._id)} />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>

      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {isAddModalOpen && <AddNewKeyword onClose={() => setIsAddModalOpen(false)} />}

      {showConfirmModal && <ConfirmationModal onResolve={handleModalResolve} />}
    </div>
  );
};

export default BlockKeywordPage;
